/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InviteOperatorCommandResult } from '../../models/invite-operator-command-result';
import { InviteOperatorRequestDto } from '../../models/invite-operator-request-dto';

export interface ApiSessionsInviteOperatorPost$Params {

/**
 * Ongoing conversation, from the `X-Session-Id` header.
 */
  'X-Session-Id'?: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
  
    /**
     * Rule the agent picked, by index, plus the summary it composed.
     */
    body?: InviteOperatorRequestDto
}

export function apiSessionsInviteOperatorPost(http: HttpClient, rootUrl: string, params?: ApiSessionsInviteOperatorPost$Params, context?: HttpContext): Observable<StrictHttpResponse<InviteOperatorCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiSessionsInviteOperatorPost.PATH, 'post');
  if (params) {
    rb.header('X-Session-Id', params['X-Session-Id'], {});
    rb.header('x-space-id', params['x-space-id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InviteOperatorCommandResult>;
    })
  );
}

apiSessionsInviteOperatorPost.PATH = '/api/Sessions/invite-operator';
